"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InstantResultListRow = void 0;
var _mui = require("@ori-ui/mui");
var _culture = require("@ori/culture");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _useDeliveryChannelAddressQuery = require("../../api/useDeliveryChannelAddressQuery");
var _models = require("../../models");
var _utils = require("../../utils");
var _FormattedMessage = require("../FormattedMessage");
var _shared = require("../shared");
var _HighlightText = require("./HighlightText");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')(({
  theme
}) => (0, _shared.instantResultRowWrapperStyles)(theme));
const PickupPointInfo = (0, _mui.styled)('div')({
  ..._shared.instantResultInstructionsStyles
});
const PickupPointInstruction = (0, _mui.styled)('div')(({
  ownerState: {
    isLabel
  }
}) => (0, _shared.instantResultInstructionsItemStyles)(isLabel));
const DeliveryMethodTag = (0, _mui.styled)(_mui.Chip)(({
  theme
}) => (0, _shared.deliveryMethodTagStyles)(theme));
const ShippingFee = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => (0, _shared.shippingFeeStyles)(theme));
const AdditionalInfo = (0, _mui.styled)('div')(({
  theme
}) => (0, _shared.additionalInfoStyles)(theme));
const StockIndicator = (0, _mui.styled)('span')(({
  ownerState: {
    isOutOfStock
  },
  theme
}) => (0, _shared.stockIndicatorStyles)(isOutOfStock, theme));
const OutOfStockMessage = (0, _mui.styled)('div')(({
  theme
}) => (0, _shared.outOfStockMessageStyles)(theme));
const InstantResultListRow = ({
  display,
  instantResultPickupPoint,
  searchTerm,
  selectInstantResult
}) => {
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const {
    deliveryChannelId,
    deliveryMethod,
    estimatedDeliveryDate,
    outOfStockQuantity,
    shippingFee
  } = instantResultPickupPoint;
  const {
    deliveryChannelAddress
  } = (0, _useDeliveryChannelAddressQuery.useDeliveryChannelAddressQuery)(deliveryChannelId);
  const {
    streetAddress: street,
    zipcode: zipCode
  } = deliveryChannelAddress ?? {};
  const deliveryMethodTranslationKey = (0, _utils.getDeliveryMethodTranslationKey)(deliveryMethod);
  const pickupPoint = {
    ...instantResultPickupPoint,
    ...deliveryChannelAddress,
    street,
    zipCode
  };
  const handleInstantResultClick = (0, _react.useCallback)(() => {
    selectInstantResult(instantResultPickupPoint);
  }, [instantResultPickupPoint, selectInstantResult]);
  const instantResultTestId = `${_models.TestId.InstantResultListRow}-${deliveryChannelId}`;
  const isDescriptionDisplayed = display.includes(_models.PickupPointDisplayType.Description);
  const isOutOfStock = outOfStockQuantity > 0;
  const stockInfoOwnerState = {
    isOutOfStock
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Root, {
    onClick: handleInstantResultClick // Alternatively use onMouseDown as it has higher priority than onBlur in SearchField
    ,

    ...getTestIdProps(instantResultTestId),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(DeliveryMethodTag, {
      variant: "tag",
      label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
        id: deliveryMethodTranslationKey
      }),
      ...getTestIdProps(`${instantResultTestId}-${_models.TestId.DeliveryMethodTag}`)
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(PickupPointInfo, {
      children: display.map(displayType => {
        const displayValue = (0, _utils.getPickupPointValueByDisplayOrder)(displayType, pickupPoint);
        const isCvId = displayType === _models.PickupPointDisplayType.CvId;
        const isLabel = displayType === _models.PickupPointDisplayType.Description || isCvId && !isDescriptionDisplayed;
        const instructionOwnerState = {
          isLabel
        };
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(PickupPointInstruction, {
          ownerState: instructionOwnerState,
          children: [displayValue && isCvId ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
              id: deliveryMethodTranslationKey
            }), ': ']
          }) : null, displayValue ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_HighlightText.HighlightText, {
            deliveryChannelId: deliveryChannelId,
            searchTerm: searchTerm,
            children: displayValue
          }) : null]
        }, `pickup-point-instruction-${deliveryChannelId}-${displayType}`);
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ShippingFee, {
      ...getTestIdProps(`${instantResultTestId}-${_models.TestId.ShippingFee}`),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_culture.FormatCurrency, {
        children: shippingFee
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(AdditionalInfo, {
      children: [estimatedDeliveryDate ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        ...getTestIdProps(`${instantResultTestId}-${_models.TestId.EstimatedDelivery}`),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_culture.FormatDate, {
          value: estimatedDeliveryDate,
          format: _culture.DateFormat.MonthDay
        })
      }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(StockIndicator, {
        ownerState: stockInfoOwnerState
      }), isOutOfStock ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(OutOfStockMessage, {
        ...getTestIdProps(`${instantResultTestId}-${_models.TestId.OosFlag}`),
        children: [outOfStockQuantity, " ", /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
          id: "outOfStock"
        })]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
          id: "allInStock"
        })
      })]
    })]
  });
};
exports.InstantResultListRow = InstantResultListRow;